
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export const useAllBreeders = () => {
  return useQuery({
    queryKey: ['all-breeders'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('profiles')
        .select(`
          id,
          business_name,
          first_name,
          last_name,
          location,
          location_coordinates
        `)
        .eq('user_type', 'breeder')
        .not('location_coordinates', 'is', null);

      if (error) {
        console.error('Error fetching breeders:', error);
        throw error;
      }

      if (!data || data.length === 0) {
        return [];
      }

      // Transform the data to match the expected map format
      const transformedData = data.map((breeder, index) => {
        let lat = 40.7128; // Default NYC lat
        let lng = -74.0060; // Default NYC lng

        if (breeder.location_coordinates) {
          try {
            let coordinates;
            
            // If it's a string, parse it as JSON
            if (typeof breeder.location_coordinates === 'string') {
              coordinates = JSON.parse(breeder.location_coordinates);
            } else {
              coordinates = breeder.location_coordinates;
            }
            
            // Check if coordinates has longitude and latitude properties
            if (coordinates && typeof coordinates === 'object' && 
                'longitude' in coordinates && 'latitude' in coordinates &&
                typeof coordinates.longitude === 'number' && 
                typeof coordinates.latitude === 'number') {
              lat = coordinates.latitude;
              lng = coordinates.longitude;
            }
          } catch (error) {
            console.log('Error parsing coordinates for breeder:', breeder.id, error);
          }
        }

        return {
          id: index + 1,
          name: breeder.business_name || 
                `${breeder.first_name || ''} ${breeder.last_name || ''}`.trim() || 
                'Unknown Breeder',
          location: breeder.location || 'Location not specified',
          lat: lat,
          lng: lng
        };
      });

      return transformedData;
    },
  });
};
